<template>
  <QuadroPrincipal
    :key="getRenderKey"
    :titulo="beneficiosNome"
    :classe="classe"
    :class="['beneficios-impressao', { 'no-print': !selecionouBeneficio }]"
  >
    <div class="notificacao-container">
      <Notificacao v-if="alteracaoImportacao" :tipo="'alerta'" :texto="textoImportacao" />
    </div>
    <div
      v-if="!!beneficiosAlerta.length"
      v-for="(alerta, index) in beneficiosAlerta"
      :key="index"
      class="notificacao-container"
    >
      <Notificacao :tipo="'alerta'" :texto="alerta.alerta" />
    </div>
    <div class="quadro-beneficio-impressao" v-if="!!beneficiosFiltrados.length">
      <Registro class="beneficios-cabecalho" paddingSemCheckBox>
        <label>Benefício</label>
        <label>Convênio</label>
        <label>Descrição</label>
      </Registro>
      <div
        class="beneficios-content"
        :class="{ 'remover-borda': index !== beneficiosFiltrados.length - 1 }"
        v-for="(beneficio, index) in beneficiosFiltrados"
        :key="beneficio.id_imposto"
      >
        <CheckButton
          :seleciona="seleciona"
          :selecionado="selecionouBeneficio"
          :dado="beneficio"
          :classe="classe"
          :loading="loading"
        />

        <Registro
          :class="[
            'registro-beneficio-impressao',
            { 'no-print': beneficio.id_imposto != beneficioSelecionado.id_imposto },
            'registro-borda'
          ]"
        >
          <div>{{ beneficio.label }}</div>
          <div>{{ beneficio.tipo_beneficio ? beneficio.tipo_beneficio : "-" }}</div>
          <div>{{ beneficio.texto }}</div>
        </Registro>
      </div>
      <QuadroAlertaZfm
        class="alerta-zfm-ben"
        v-if="selecionouBeneficio"
        :alerta="beneficioSelecionado"
      />
      <LegislacaoEstadual
        v-if="selecionouBeneficio && !!beneficioSelecionado.tipo_beneficio"
        :beneficio="beneficioSelecionado"
      />
      <LegislacaoEstadual
        v-if="selecionouBeneficio"
        :tipo="'legislacao'"
        :beneficio="beneficioSelecionado"
      />
    </div>
  </QuadroPrincipal>
</template>

<script>
import CheckButton from "@/components/Button/CheckButton.vue";
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";
import Registro from "@/components/Registro/Registro.vue";
import LegislacaoEstadual from "@/components/LegislacaoEstadual/LegislacaoEstadual.vue";
import Notificacao from "@/components/Notificacao/Notificacao.vue";
import QuadroAlertaZfm from "@/components/QuadroAlertaZfm/QuadroAlertaZfm.vue";

import { mapGetters } from "vuex";

export default {
  name: "BeneficiosIcms",

  props: {
    id: String | Number,
    beneficios: Array | Object,
    dadosForm: Array | Object,
    beneficioSelecionado: Object,
    classe: String,
    loading: Boolean,
    seleciona: Function,
    selecionouBeneficio: Boolean
  },

  inject: ["alteracaoImportacao"],

  components: {
    CheckButton,
    LegislacaoEstadual,
    QuadroPrincipal,
    Registro,
    Notificacao,
    QuadroAlertaZfm
  },

  data() {
    return {
      textoImportacao:
        "De acordo com a Súmula do Superior Tribunal Federal (STF) nº 575, o mesmo tratamento tributário conferido ao produto similar nacional, em operação interna, poderá ser aplicado na operação de importação, desde que o produto seja proveniente de países signatários de Acordo Geral de Tarifas Aduaneiras (GATT), sendo necessário, também, observar as disposições da legislação estadual."
    };
  },

  created() {},

  computed: {
    ...mapGetters("reRender", ["getRenderKey"]),
    beneficiosFiltrados() {
      return this.beneficios.filter(beneficio => beneficio.ordem != 101);
    },
    beneficiosAlerta() {
      return this.beneficios.filter(beneficio => beneficio.ordem == 101);
    },
    beneficiosNome() {
      let nome = "BENEFÍCIOS";
      let area = [];
      let decrescente = (a, b) => {
        if (a > b) {
          return -1;
        }
        if (b > a) {
          return 1;
        }
        return 0;
      };
      this.beneficios.forEach(zfmAlc => {
        if (zfmAlc.zfm_alc && !area.includes(zfmAlc.zfm_alc)) {
          area.push(zfmAlc.zfm_alc);
        }
      });
      area.sort(decrescente).forEach(zfmAlc => {
        if (nome == "BENEFÍCIOS") {
          nome = nome + " " + zfmAlc;
        } else {
          nome = nome + "/" + zfmAlc;
        }
      });
      return nome;
    }
  },

  methods: {}
};
</script>

<style lang="scss" scoped>
.beneficios-content {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  .registro-content {
    padding: 0.35rem 9px;
  }
  &:nth-child(odd) {
    .registro-content {
      background: #ececec;
    }
  }

  &:nth-child(even) {
    .registro-content {
      background: #e0e0e0;
    }
  }

  &:last-child {
    .registro-borda {
      border-radius: 0 0 2px 2px;
    }
  }
}

.remover-borda .registro-content {
  border-bottom: none;
}

.beneficios-cabecalho,
.registro-content {
  display: grid;
  grid-template-columns: 4fr 3fr 8fr;
  border-radius: 2px 2px 0 0;
  padding: 0.35rem 9px;
}

.beneficios-cabecalho {
  font-weight: 700;
  align-items: center;
  label {
    margin-bottom: 0;
  }
}
.notificacao-container {
  margin-left: 0.9rem;
}
.alerta-zfm-ben {
  margin-top: 1rem;
  display: flex;
}
.registro-borda {
  border-radius: 0px;
}

@media only print {
  .remover-borda .registro-content {
    border: 1px solid #ccc;
    margin-top: -1px;
  }
  .registro-beneficio-impressao {
    margin-top: -1px;
  }
  .beneficios-impressao {
    page-break-inside: avoid;
  }
  .notificacao-container {
    margin-left: 0;
  }
}
</style>
